<template>
  <MultiSelect
    :label="$i18n('interface.novo_filtro.status')"
    :campos="campos"
    :filtro="filtro"
    :filtro_id="filtro.filtro"
    :path="path"
    @atualizar="onAtualizar"
  />
</template>
<script>
import { computed, getCurrentInstance, toRef } from 'vue';
import MultiSelect from '../../components/MultiSelect.vue';
import { useFiltroMultiSelect } from '../../composables/useFiltroMultiSelect';

const STATUS_IDS = [
  'vencidas',
  'vencimento_iminente',
  'pagas',
  'nao_pagas',
  'nao_vencidas',
  'excluidas',
  'conciliadas',
];

export default {
  components: { MultiSelect },
  props: {
    filtro: { type: Object, required: true },
    path: { type: String, required: true },
  },
  setup(props) {
    const { proxy } = getCurrentInstance();

    const campos = computed(() =>
      STATUS_IDS.map(id => ({
        id,
        name: proxy.$i18n(`interface.select_conta_a_pagars.${id}`),
      }))
    );

    const { onAtualizar } = useFiltroMultiSelect({
      filtro: toRef(props, 'filtro'),
      path: toRef(props, 'path'),
    });

    return { campos, onAtualizar };
  },
}
</script>
